<template>
    <div class="animated fadeIn">
        <Forms
            ref="frmGroup"
            :title="'CADASTRO DE PARÂMETROS VIEWB'"
            showClearButton
            showSaveButton
            @Clear="onClear"
            @Save="onSave"
        >
            <div class="form-group col-md-12 row">
                <div class="col-md-3 pb-3">
                    <label for="usuarioInput">
                        <small v-if="form.usuario.required" class="text-danger">*</small> Usuário:
                    </label>
                    <div class="input-group">
                        <b-form-input
                            type="text"
                            id="usuarioInput"
                            name="usuarioInput"
                            v-model="form.usuario.value"
                            :maxlength="form.usuario.maxlength"
                            :required="form.usuario.required"
                            :state="form.usuario.state"
                        />
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="senhaInput">
                        <small v-if="form.senha.required" class="text-danger">*</small> Senha:
                    </label>
                    <div class="input-group">
                        <b-form-input
                            type="password"
                            id="senhaInput"
                            name="senhaInput"
                            v-model="form.senha.value"
                            :maxlength="form.senha.maxlength"
                            :required="form.senha.required"
                            :state="form.senha.state"
                        />
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12 row">
                <div class="col-md-6">
                    <label for="urlBaseInput">
                        <small v-if="form.urlBase.required" class="text-danger">*</small> URL base:
                    </label>
                    <div class="input-group">
                        <b-form-input
                            type="text"
                            id="urlBaseInput"
                            name="urlBaseInput"
                            v-model="form.urlBase.value"
                            :maxlength="form.urlBase.maxlength"
                            :required="form.urlBase.required"
                            :state="form.urlBase.state"
                        />
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="urlBaseInput">
                        <small v-if="form.urlApiBase.required" class="text-danger">*</small> URL API base:
                    </label>
                    <div class="input-group">
                        <b-form-input
                            type="text"
                            id="urlApiBaseInput"
                            name="urlApiBaseInput"
                            v-model="form.urlApiBase.value"
                            :maxlength="form.urlApiBase.maxlength"
                            :required="form.urlApiBase.required"
                            :state="form.urlApiBase.state"
                        />
                    </div>
                </div>
            </div>
        </Forms>
    </div>
</template>

<script>
import ParametroViewbRepository from '@/shared/http/repositories/configurations/parametroViewb.js'

import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

const viewbForm = {
  usuario: {
    value: '',
    maxlength: '100',
    required: true,
    state: null
  },
  senha: {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  },
  urlBase: {
    value: null,
    maxlength: '100',
    required: true,
    state: null
  },
  urlApiBase: {
    value: null,
    maxlength: '100',
    required: true,
    state: null
  }
}

const viewbData = {
  id: 1,
  usuario: null,
  senha: null,
  urlBase: null,
  urlApiBase: null
}

export default {
  name: 'ViewbParams',
  mixins: [ActionsForm],
  data () {
    return {
      form: viewbForm,
      data: viewbData
    }
  },
  methods: {
    async onLoad () {
      try {
        const response = await ParametroViewbRepository.GetParams()
        if (response.status === 200) {
          this.onEdit(response.data)
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    async onCreate () {
      try {
        loading.push()

        this.data.id = parseInt(this.data.id)
        const response = await ParametroViewbRepository.Create(this.data)
        if (response.status === 201) {
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      } finally {
        loading.pop()
      }
    },
    async onUpdate () {
      try {
        const response = await ParametroViewbRepository.UpdateParams(this.data)
        if (response.status === 200) {
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      } finally {
        loading.pop()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/viewb/ViewbParams.vue